import Vue from 'vue';
import Element from 'element-ui';
import '@/assets/scss/app.scss';
import locale from 'element-ui/lib/locale/lang/ru-RU';

Vue.use(Element, {
  locale,
  size: 'small'
});
